import React from "react";
import Navbar from "../navbar/Navbar";
import Footer from "../footer/Footer";

export const withLayout = (props) => {
  // console.log("layout props", props);
  const { children } = props;
  const showFooter = withFooter(props.location.pathname);

  return (
    <>
      <Navbar location={props.location.pathname} />
      <div
        style={{
          paddingTop: props.location.pathname === "/" ? 0 : 88,
          backgroundColor: "#f8f9fd",
        }}
      >
        {children}
      </div>
      {showFooter && <Footer />}
    </>
  );
};

const withFooter = (location) => {
  switch (location) {
    case "/login":
    case "/register":
    case "/newPasswordRequest":
    case "/templates":
    case "/editor":
      return true;
    default:
      return false;
  }
};
